import Mixin from "../../mixin.js";
import FormInputs from "../../services/inputs-service.js";
import Utils from "../../services/utils-service.js";
import InputSelect from "./InputSelect.js";
import InputText from "./InputText.js";
import Label from "./Label.js";
import Funnel from "../../services/funnel-service.js";

const template = `
    <div class="grid collapse phone-type-combo" v-show="fs.display(input)">
        <div class="s6 clm no-left-padding no-right-padding left" :class="input.left_class">
           <qt-input-text 
           :iuid="iuid" />
         </div>
         <div class="s6 clm no-right-padding right" :class="input.right_class">
            <label
                :label-for="input.id+'_type'"
                :for="input.id+'_type'"
                class="phone-type"
                :data-uid="iuid+'pt_lb'"
                :id="'label_'+input.uid+'_type'"
                :name="'label_'+input.uid+'_type'"
            >
                <span>Type:</span>
            </label>
            <select
                :id="input.id+'_type'"
                :required="input.validation.required"
                :name="input.element_name+'_type'"
                :value="input.type_value"
                @change="exec($event, input)"
                v-bind="validationRules"
                :data-uid="input.id+'_type'"
                :aria-required="input.validation.required"
                :aria-labelledby="'label_'+input.uid+'_type'"
                :aria-describedby="input.id+'_type_error'"
            >
            <option v-for="option in input.options" :value="option.value">{{ option.label }}</option>
            </select>
         </div>
    </div>
`;
export default {
    name: 'qt-input-phone',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-input-text': InputText,
        'qt-select': InputSelect,
        'qt-label': Label
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules() {
            // v-bind="validationRules"
            const validation = { ...this.input.validation };
            if (validation.minLength)
                delete validation.minLength;
            if (validation.maxLength)
                delete validation.maxLength;
            if (validation.pattern)
                delete validation.pattern
            return validation;
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedMask: function () {
            return this.input.validation.mask
        }
    },
    mounted: function () {
        console.log(this.input.uid, this.input.options);
        if (!this.input.options[0]) { return }
        if ((!this.input.type_value || !this.input.value) && this.input.options[0].value != '') {
            if (this.input.type_value != undefined) {
                //for the input phone select
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'type_value', val: this.input.options[0].value });
            }
            else if (this.input.value != undefined) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.input.options[0].value });
            }
        }
    },
    methods: {
        exec: function (e, input) {
            const uid = 'in_phone';
            if (e.target.value !== undefined) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'type_value', val: e.target.value });
            }
        }
        /* John M: now using mixin.js functions.
        exec: function (e) {
            //First commit mutation then process business logic.
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            fi.isValid(this.input);
            this.updateValue(e);
            fi.eventHandler(e, this.input);
        },
        updateValue: function (e) {
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: e.target.value });
        },
        isTruthy: function (val) {
            return Utils.isTruthy(val);
        } */
    }
};
